import { render, staticRenderFns } from "./fileAdd.vue?vue&type=template&id=84539a6a&scoped=true&"
import script from "./fileAdd.vue?vue&type=script&lang=js&"
export * from "./fileAdd.vue?vue&type=script&lang=js&"
import style0 from "./fileAdd.vue?vue&type=style&index=0&id=84539a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84539a6a",
  null
  
)

export default component.exports